'use strict'

/* -----------------------------------------------------------------------------
 * symptom log history types
 *
 * The shapes the history screen groups symptom tracking entries into, by month
 * and then by day.
 * -------------------------------------------------------------------------- */

export enum Severity {
  NONE = 0,
  MILD,
  MODERATE,
  SEVERE
}

export type SymptomLog = {
  date: string
  log_id: number
  severity: Severity
  symptom_id: number
}

export type Month =
  | '01'
  | '02'
  | '03'
  | '04'
  | '05'
  | '06'
  | '07'
  | '08'
  | '09'
  | '10'
  | '11'
  | '12'

export type SymptomDayLog = SymptomLog & {
  symptom: string
}

export type SymptomLogHistoryDate = {
  date: string
  logs: SymptomDayLog[]
}

export type SymptomLogHistorySection = {
  month: Month
  data: SymptomLogHistoryDate[]
}
